import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ID_REGIMEN_CONTRATO_CIVIL} from "components/Sidebar/Sidebar_Principal_Submenu";

export const ID_REGIMEN_CONTRATO_LOSEP:number = 7;
export const ID_REGIMEN_CONTRATO_LOES:number = 8;
export const ID_REGIMEN_CONTRATO_CODIGO_TRABAJO:number = 9;

export enum REGIMEN_USUARIO  {
    LOSEP = 7,
    LOES = 8,
    CODIGO_TRABAJO=9,
    CONTRATO_CIVIL=0
    
}

export const ObtenerDescripcionSegunIDRegimen = (id_regimen: number): string => {
    const parseo_regimen_id = [
        { id_regimen: ID_REGIMEN_CONTRATO_LOSEP, nombre: "LOSEP" },
        { id_regimen: ID_REGIMEN_CONTRATO_LOES, nombre: "LOES" },
        { id_regimen: ID_REGIMEN_CONTRATO_CODIGO_TRABAJO, nombre: "CÓDIGO DE TRABAJO" },
        { id_regimen: 0, nombre: "CIVIL" },
    ]

    var valor = "";

    parseo_regimen_id.map((value, index) => {
        if (id_regimen === value.id_regimen)
            valor = value.nombre
    })

    return valor;
}

export function VerificarSoloTieneContratoRegimen (regimenABuscar:number,datosUsuario:UserData){
    if(datosUsuario === undefined || datosUsuario === null){
        return false
    }
    var cantidad_regimen = datosUsuario.regimen_usuario.length;
    var tieneElRegimenIndicado = datosUsuario.regimen_usuario.includes(regimenABuscar);
    return cantidad_regimen === 1 && tieneElRegimenIndicado;
}    

// export function VerificarServidorTieneRegimen (regimenABuscar:REGIMEN_USUARIO,datosUsuario:UserData){
//     if(datosUsuario === undefined || datosUsuario === null){
//         return false
//     }
//     const {regimen_usuario} = datosUsuario;
    
//     if(regimen_usuario.length == 0){
//         return false
//     }

//     return regimen_usuario.find((regimen)=> regimen == regimenABuscar) !== undefined;



// }

export function VerificarServidorTieneRegimen (regimenABuscar:REGIMEN_USUARIO,listadoRegimen:number[]|undefined|null){
    if(listadoRegimen === undefined || listadoRegimen === null){
        return false
    }

    
    if(listadoRegimen.length == 0){
        return false
    }

    return listadoRegimen.find((regimen)=> regimen == regimenABuscar) !== undefined;



}


export function VerificarServidorSoloTieneCodigoTrabajo(listadoRegimen:number[]|undefined|null){
    if(listadoRegimen === undefined || listadoRegimen === null){
        return false
    }

    
    if(listadoRegimen.length === 0){
        return false
    }

    const tieneRegimenCodigoTrabajo:boolean =  listadoRegimen.find((regimen)=> regimen == REGIMEN_USUARIO.CODIGO_TRABAJO) !== undefined;

    if(listadoRegimen.length === 1){
        return tieneRegimenCodigoTrabajo;
    }
    else{
        
        const tieneRegimenDistintoCodigoTrabajo:boolean =  listadoRegimen.find((regimen)=> regimen != REGIMEN_USUARIO.CODIGO_TRABAJO) !== undefined;
        return !tieneRegimenDistintoCodigoTrabajo && tieneRegimenCodigoTrabajo;
    }

    
    

}